<template>
  <div class="border">
    <div style="padding:1rem">
      <PageHeader title="อันดับบทเรียน"></PageHeader>
      <b-row>
        <b-col cols="12">
          <lectureRanking
            :apiRoute="
              `/v1/analytics/courses/getCourseLectureRanking?cId=${cId}&template=A`
            "
            :perPage="20"
          ></lectureRanking>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import lectureRanking from "./panel/IndividualCourseLectureRankingPanel";
import moment from "moment";
import PageHeader from "@/components/layouts/PageHeader.vue";
export default {
  data() {
    return {
      startDate: moment().format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
      cId: this.$route.params.cId
    };
  },
  components: {
    PageHeader,
    lectureRanking
  }
};
</script>
<style scoped></style>
